import { useState } from 'react'
import styled from 'styled-components'
import { toast } from 'react-toastify'
import taskLinksAPI from 'features/taskLinks/taskLinksAPI'
import { errorMessage } from 'features/taskLinks/linkCopy'

const UndoUnlinkToast = ({ text, actionId, taskId, relation, onRestored, closeToast }) => {
  const [working, setWorking] = useState(false)

  const undo = async () => {
    setWorking(true)
    try {
      await taskLinksAPI.link(actionId, taskId, relation || 'handles')
      closeToast?.()
      toast.success('Link restored.')
      onRestored?.()
    } catch (err) {
      setWorking(false)
      toast.error(errorMessage(err))
    }
  }

  return (
    <Wrap>
      <span>{text}</span>
      <UndoButton type='button' onClick={undo} disabled={working}>
        {working ? 'Restoring…' : 'Undo'}
      </UndoButton>
    </Wrap>
  )
}

export const unlinkedToast = props => <UndoUnlinkToast {...props} />

export default UndoUnlinkToast

const Wrap = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

const UndoButton = styled.button`
  min-height: 40px;
  padding: 0 14px;
  border: 1px solid currentColor;
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`
